import { Column } from "components/flexComponents/MultiColumnContainer/model/Column";
import { TwoColumn } from "components/flexComponents/MultiColumnContainer/decorators/TwoColumn/TwoColumn";

/**
 *
 * Constructs a two column starting from the right as such:
 *
 * ------------
 * | 2     1  |
 * |          |
 * | 3        |
 * ------------
 *
 * If 1 is missing:
 * ------------
 * | 3     2  |
 * |          |
 * |          |
 * ------------
 *
 */
export class OneToManyTwoColumnRight extends TwoColumn {
  public constructor(column: Column) {
    super(column) /* istanbul ignore next */;
    this.setLeftAndRightColumn(this.wrappedColumn.modules.splice(1), [this.wrappedColumn.modules[0]]);
  }
}
